module.exports = __webpack_public_path__ + "img/chackra-removebg.24c5ea58.png";